import {
  Component,
  ViewEncapsulation,
  OnInit,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1204Model } from './kymw1204.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW1204InputModel } from './vo/kymw1204-input.model';

/**
 * メモ内容を管理するクラス
 *
 * @export KYMW1204Component
 * @class KYMW1204Component
 */
@Component({
  selector: 'app-kymw1204',
  templateUrl: 'kymw1204.component.html',
  styleUrls: ['kymw1204.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1204Component
  extends PlessViewHelperSub
  implements OnInit
{
  public model: KYMW1204Model = new KYMW1204Model();
  // 親画面からの連携値
  inputVo: KYMW1204InputModel;

  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW1204Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1204';

  }

  /**
   * ボタン押下 確定
   *
   * @memberof KYMW1204Component
   */
  public eventConfirm_CLICKHandler() {
    this.model.output = {
      catalogMemo: this.model.catalogMemo,
      copyCatalogMemoFlg: this.model.copyCatalogMemoFlg,
    };
    this.closeFunction(this.model.output);
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡されるデータ
   * @memberof KYMW1204Component
   */
  public setInterfaceParam(param: KYMW1204InputModel): void {
    // 親画面のinputVOをそのまま受け取る
    this.inputVo = param;
    this.model.catalogMemo = param.catalogMemo;
    this.model.copyCatalogMemoFlg = param.copyCatalogMemoFlg;
    this.model.cycleFixedFlg = param.cycleFixedFlg;
  }
}
